export default __webpack_public_path__ + "static/media/external-landing.e395c755.svg";